export default class GameOptions {
    static mapUrl = 'https://i.imgur.com/a993R8f.png';
    static websocketUrl = 'wss://pixel-art.kesarx.repl.co';
}